import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import DashboardContent from "../../components/Dashboard/DashboardContent";
import { getVesselMasterList } from "../../redux/actions/mastersAction";
import { getDashboardUnreadDefectList } from "../../redux/actions/dashboardAction";
import { useDispatch, useSelector } from "react-redux";

const Dashboard = () => {
  const dispatch = useDispatch();


  

  useEffect(() => {
    dispatch(
      getVesselMasterList({
        active: "",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
   
  }, []);

  return (
    <>
      <Sidebar activeTab="Dashboard" title="Dashboard">
        <Box className="globalContainer_For_Content">
          <DashboardContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Dashboard;
